import * as React from 'react'
import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  List,
  Stack,
  Typography,
} from '@mui/material'
import { Save } from '@mui/icons-material'
import { useMutation, useQuery } from 'react-query'
import StudyService from '../../../APIs/Python/APIs/StudyService'
import { AxiosResponse } from 'axios'
import { useGlobalContext } from '../../../Contexts/GlobalTriggers'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import VisibleListOption from './VisibleListOption'
import { stackGap } from '../../../Constants&Theme/Spacing'

export default function VisibleList() {
  const { whoAmI } = useUserContext()
  const { setLoadingDialog } = useGlobalContext()
  const { setError } = useMessagePopupContext()
  const { studyEdit } = useStudyContext()

  const [checked, setChecked] = useState<string[]>([])
  const [order, setOrder] = useState<string[]>([])
  const [save, setSave] = useState(false)

  const { data, isLoading } = useQuery<string[], AxiosResponse>(
    ['StudyService', 'getMetaAnimalAttributes'],
    () => StudyService.getMetaAnimalAttributes(whoAmI),
    {
      enabled: !!whoAmI,
      onError: (err) => setError(err),
    },
  )

  useEffect(() => {
    if (studyEdit?.ShownAnimalDetails) {
      setChecked(studyEdit?.ShownAnimalDetails)
    }
  }, [studyEdit])

  useEffect(() => {
    if (data) {
      const disabled = data.filter((option) => !checked.includes(option))
      setOrder([...checked, ...disabled])
    }
  }, [checked, data])

  const { mutate: updateStudy, reset: resetUpdate } = useMutation<
    any,
    AxiosResponse
  >(
    () =>
      StudyService.updateStudy(whoAmI, studyEdit!.StudyID!, {
        ShownAnimalDetails: checked,
      }),
    {
      onSuccess: () => {
        setSave(false)
        setLoadingDialog(false)
      },
      onError: (err) => {
        setLoadingDialog(false)
        setError(err)
      },
    },
  )

  return (
    <Box
      sx={{ flex: 1, display: 'flex', flexDirection: 'column', ml: 1, mt: 1 }}
    >
      <Typography sx={{ fontWeight: 600 }}>Visible Animal Details</Typography>
      <Stack
        gap={stackGap.row}
        direction={'row'}
        sx={{ alignItems: 'flex-end' }}
      >
        <Typography sx={{ fontWeight: 400, mt: 1, fontSize: '0.9rem' }}>
          Select and order the animal details to be displayed during data entry
          and when viewing study data for an animal
        </Typography>
        <Box>
          <Button
            endIcon={<Save />}
            color={'success'}
            variant={'contained'}
            disabled={!save || !studyEdit}
            onClick={() => {
              setLoadingDialog(true)
              resetUpdate()
              updateStudy()
            }}
          >
            Save
          </Button>
        </Box>
      </Stack>
      {isLoading ?
        <CircularProgress sx={{ m: 2 }} />
      : <List sx={{ width: 1 }}>
          {order.map((option, index) => (
            <VisibleListOption
              setChecked={setChecked}
              setSave={setSave}
              option={option}
              index={index}
              checked={checked}
            />
          ))}
        </List>
      }
    </Box>
  )
}
